import { Link } from 'gatsby'
import { ComponentProps, forwardRef } from 'react'

import { BreadcrumbsNavigation, traverse } from '@karakuri-web/faq-component'
import { Breadcrumb, BreadcrumbType, CategorySub, Hierarchy } from '@karakuri-web/faq-type'

interface Props {
  breadcrumb?: Breadcrumb
  breadcrumbType?: BreadcrumbType | null
  relatedCategories?: CategorySub[]
  hierarchies: Hierarchy[]
  dictionary: Record<string, CategorySub>
  topTitle: string
}
export function BreadcrumbWidget({
  breadcrumb,
  breadcrumbType,
  relatedCategories = [],
  hierarchies,
  dictionary,
  topTitle,
}: Props) {
  const LinkComponent = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(
    function LinkComponent(props: ComponentProps<typeof Link>, ref) {
      const found = hierarchies.findIndex(h => h.link === props.to)
      const h = hierarchies.slice(0, found)
      const newProps: Omit<ComponentProps<typeof Link>, 'to'> = {}
      if (h.length > 0) {
        newProps.state = { hierarchies: h }
      }
      return <Link ref={ref as any} {...{ ...props, ...newProps }} />
    }
  )

  return (
    <div className="faq-search-navigation">
      <BreadcrumbsNavigation
        breadcrumb={breadcrumb}
        breadcrumbType={breadcrumbType}
        relatedCategories={relatedCategories}
        tags={[
          { link: '/', title: topTitle },
          ...relatedCategories
            .filter(x => !x.isParent)
            .map(c => {
              const title = c.title || ''
              const link = traverse(c, dictionary, [{ id: c.id || '', title }])
                .reverse()
                .reduce<string[]>(
                  (acc, h) => {
                    acc.push(h.id)
                    return acc
                  },
                  ['/search']
                )
                .join('/')
              return { link, title }
            }),
        ]}
        topTitle={topTitle}
        LinkComponent={LinkComponent}
      />
    </div>
  )
}
